import { SelectInput } from "react-admin";
import { useField } from "react-final-form";

export const deferralCodeList = [
  { id: "REV-EXT-1M", name: "REV-EXT-1M" },
  { id: "REV-EXT-2M", name: "REV-EXT-2M" },
  { id: "REV-EXT-3M", name: "REV-EXT-3M" },
  { id: "REV-EXT-4M", name: "REV-EXT-4M" },
  { id: "REV-EXT-5M", name: "REV-EXT-5M" },
  { id: "REV-EXT-6M", name: "REV-EXT-6M" },
  { id: "REV-EXT-7M", name: "REV-EXT-7M" },
  { id: "REV-EXT-8M", name: "REV-EXT-8M" },
  { id: "REV-EXT-9M", name: "REV-EXT-9M" },
  { id: "REV-EXT-10", name: "REV-EXT-10" },
  { id: "REV-EXT-11", name: "REV-EXT-11" },
  { id: "REV-EXT-1Y", name: "REV-EXT-1Y" },
];

const DeferralCodeInput = () => {
  const deferralStartDateField = useField("deferralStartDate");
  return (
    <SelectInput
      source="deferralCode"
      choices={deferralCodeList}
      allowEmpty
      onChange={(event: any) => {
        console.log(event);
        if (event.target.value === "") {
          deferralStartDateField.input.onChange("");
        }
      }}
    />
  );
};

export default DeferralCodeInput;
